"use strict";

var _possibleConstructorReturn = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sessionData_1 = require("./sessionData"); // import { BLOCKSTACK_GAIA_HUB_LABEL } from '../storage/hub'


var authConstants_1 = require("./authConstants");

var errors_1 = require("../errors"); // import { Logger } from '../logger'

/**
 * An abstract class representing the SessionDataStore interface.

 */


var SessionDataStore =
/*#__PURE__*/
function () {
  function SessionDataStore(sessionOptions) {
    _classCallCheck(this, SessionDataStore);

    if (sessionOptions) {
      var newSessionData = new sessionData_1.SessionData(sessionOptions);
      this.setSessionData(newSessionData);
    }
  }

  _createClass(SessionDataStore, [{
    key: "getSessionData",
    value: function getSessionData() {
      throw new Error('Abstract class');
    }
    /* eslint-disable */

  }, {
    key: "setSessionData",
    value: function setSessionData(session) {
      throw new Error('Abstract class');
    }
  }, {
    key: "deleteSessionData",
    value: function deleteSessionData() {
      throw new Error('Abstract class');
    }
  }]);

  return SessionDataStore;
}();

exports.SessionDataStore = SessionDataStore;
/**
 * Stores session data in the instance of this class.
 * @ignore
 */

var InstanceDataStore =
/*#__PURE__*/
function (_SessionDataStore) {
  _inherits(InstanceDataStore, _SessionDataStore);

  function InstanceDataStore(sessionOptions) {
    var _this;

    _classCallCheck(this, InstanceDataStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InstanceDataStore).call(this, sessionOptions));

    if (!_this.sessionData) {
      _this.setSessionData(new sessionData_1.SessionData({}));
    }

    return _this;
  }

  _createClass(InstanceDataStore, [{
    key: "getSessionData",
    value: function getSessionData() {
      if (!this.sessionData) {
        throw new errors_1.NoSessionDataError('No session data was found.');
      }

      return this.sessionData;
    }
  }, {
    key: "setSessionData",
    value: function setSessionData(session) {
      this.sessionData = session;
      return true;
    }
  }, {
    key: "deleteSessionData",
    value: function deleteSessionData() {
      this.setSessionData(new sessionData_1.SessionData({}));
      return true;
    }
  }]);

  return InstanceDataStore;
}(SessionDataStore);

exports.InstanceDataStore = InstanceDataStore;
/**
 * Stores session data in browser a localStorage entry.
 * @ignore
 */

var LocalStorageStore =
/*#__PURE__*/
function (_SessionDataStore2) {
  _inherits(LocalStorageStore, _SessionDataStore2);

  function LocalStorageStore(sessionOptions) {
    var _this2;

    _classCallCheck(this, LocalStorageStore);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(LocalStorageStore).call(this, sessionOptions));

    if (sessionOptions && sessionOptions.storeOptions && sessionOptions.storeOptions.localStorageKey && typeof sessionOptions.storeOptions.localStorageKey === 'string') {
      _this2.key = sessionOptions.storeOptions.localStorageKey;
    } else {
      _this2.key = authConstants_1.LOCALSTORAGE_SESSION_KEY;
    }

    var data = localStorage.getItem(_this2.key);

    if (!data) {
      var sessionData = new sessionData_1.SessionData({});

      _this2.setSessionData(sessionData);
    }

    return _this2;
  }

  _createClass(LocalStorageStore, [{
    key: "getSessionData",
    value: function getSessionData() {
      var data = localStorage.getItem(this.key);

      if (!data) {
        throw new errors_1.NoSessionDataError('No session data was found in localStorage');
      }

      var dataJSON = JSON.parse(data);
      return sessionData_1.SessionData.fromJSON(dataJSON);
    }
  }, {
    key: "setSessionData",
    value: function setSessionData(session) {
      localStorage.setItem(this.key, session.toString());
      return true;
    }
  }, {
    key: "deleteSessionData",
    value: function deleteSessionData() {
      localStorage.removeItem(this.key);
      this.setSessionData(new sessionData_1.SessionData({}));
      return true;
    }
  }]);

  return LocalStorageStore;
}(SessionDataStore);

exports.LocalStorageStore = LocalStorageStore;